import { gql } from "@apollo/client";
import { TRIVIA_QUESTION_FIELDS } from "../fragments";

export const TRIVIA_QUESTION_CREATE = gql`
  ${TRIVIA_QUESTION_FIELDS}
  mutation TriviaQuestionCreate($triviaConfigurationId: String!, $data: TriviaQuestionCreateInput!) {
    triviaQuestionCreate(triviaConfigurationId: $triviaConfigurationId, data: $data) {
      ...TriviaQuestionFields
    }
  }
`;

export const TRIVIA_QUESTION_UPDATE = gql`
  ${TRIVIA_QUESTION_FIELDS}
  mutation TriviaQuestionUpdate($triviaQuestionId: String!, $data: TriviaQuestionUpdateInput!) {
    triviaQuestionUpdate(triviaQuestionId: $triviaQuestionId, data: $data) {
      ...TriviaQuestionFields
    }
  }
`;

export const TRIVIA_QUESTION_DELETE = gql`
  mutation TriviaQuestionDelete($triviaQuestionId: String!) {
    triviaQuestionDelete(triviaQuestionId: $triviaQuestionId) {
      id
    }
  }
`;
